import "./App.css";
import React from "react";
import { Container, CssBaseline } from "@mui/material";
import PianoWay from "components/views/PianoWay";
import LandingFooter from "components/Footer";
import Header from "components/navbar/Header";
import ThemeContextProvider from "contexts/ThemeContext";

function App() {
  return (
    <ThemeContextProvider>
      <CssBaseline />
      <Header />
      <Container
        sx={{
          paddingTop: "50px",
        }}
      >
        <PianoWay />
      </Container>
      <LandingFooter />
    </ThemeContextProvider >
  );
}

export default App;
